import React, { Component } from 'react';
import { connect } from 'react-redux';

import NavArrow from '../../shared/components/nav-arrow';
import {Carousel} from '@hpstellar/core';
import CarouselIndicator from '../../shared/components/carousel-indicator';
import { fetchProductGroups } from '../../utility/actions';
import { Helpers } from '../../core';

import '../css/product-carousel.less';

class ProductCarousel extends Component {
    state = {
        productSkus: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let { skus } = this.props;

        //if it's an array of at least on object, assume we are done
        if (Array.isArray(skus) && typeof skus[0] === 'object') {
            this.setState({
                productSkus: this.parseProducts(skus),
            });
        } else {
            //otherwise get keyId as array of strings and request from api
            let skusId = Array.isArray(skus) ? skus : Object.keys(skus);
            if (skusId.length > 0) {
                this.props.fetchProductGroups(skusId).then(response => {
                    //If skus is an array, make sure to put response back in sorted order
                    if (Array.isArray(skus)) {
                        let productSkus = this.parseProducts(response.sort((p1, p2) => skus.indexOf(p1.sku) - skus.indexOf(p2.sku)));

                        this.setState({
                            productSkus,
                        });
                    } else {
                        this.setState({
                            productSkus,
                        });
                    }
                });
            }
        }
    }

    parseProducts = products => (
        Array.isArray(products)
        ? products.reduce( (allPrds, prd) => {
            if(prd && prd.active){
                const { violatorMsg, name, linkUrl, active, itemId } = prd || {};
                const link = prd && typeof linkUrl === 'string'
                            ? Helpers.getRelativePath(linkUrl)
                            : linkUrl;
                allPrds.push({
                    ...prd,
                    sku: null, // hide sku
                    linkUrl: link, // non-GFE anchor that wraps around tile
                    productUrl: link, // GFE component CTA
                    offerMessage: violatorMsg, // GFE component violator message
                    title: name // GFE component name
                });
            }

            return allPrds;
          }, [])
          : products
    )

    getProductSkus = productSkus => {
        const { render: productCarouselCard } = this.props;

        return productSkus.map((product, i) => productCarouselCard(`xsell-${i}`, product));
    };

    getXSellSettings = productSkusLength => {
        return {
            slidesToShow: Math.min(productSkusLength, 3),
            slidesToScroll: 1,
            ...this.controls(),
        };
    };

    getXSellMobileSettings = () => {
        return {
            slidesToShow: 1,
            slidesToScroll: 1,
            ...this.controls(),
        };
    };

    controls = () => {
        // width and customBreakpoints are avaialable if using ResponsiveProductCarousel
        let { renderBottomCenterControls = false, getSlideConfig, width, breakpoint } = this.props;
        let { productSkus } = this.state;
        let slideConfig =
            typeof getSlideConfig === 'function' ? getSlideConfig({ productSkus, width, breakpoint }) : {};
        let { customSlideCount } = slideConfig || {};
        let bottomControlComponent = renderBottomCenterControls
            ? props => <CarouselIndicator {...props} customSlideCount={customSlideCount} />
            : null;
        let rightControlComponent = getSlideConfig
            ? props => <NavArrow.NextArrow {...props} customSlideCount={customSlideCount} />
            : NavArrow.NextArrow;
        return {
            renderCenterLeftControls: NavArrow.PrevArrow,
            renderCenterRightControls: rightControlComponent,
            renderBottomCenterControls: bottomControlComponent,
        };
    };

    render() {
        const { productSkus } = this.state;
        const productSkusLength = productSkus.length;
        // customBreakpoints is only available when using ResponsiveProductCarousel
        let {
            slideWidth,
            initialSlideHeight,
            className,
            getClassName,
            wrapperClassName,
            getSlideConfig,
            header,
            customBreakpoints,
            slidesToShow,
            isMobile,
            breakpoint
        } = this.props;
        let carouselProps = {
            slideWidth,
            initialSlideHeight,
        };

        let slideConfig =
            typeof getSlideConfig === 'function' ? getSlideConfig({ productSkus, breakpoint }) : {};
        const carouselStyle = productSkusLength === 1 ? { width: '400px', margin: 'auto' } : {};
        let customClassNames =
            typeof getClassName === 'function' ? getClassName({ productSkus, breakpoint }) : null;

            return (
            <div
                className={`product-carousel-container${wrapperClassName ? ' ' + wrapperClassName : ''}${
                    customClassNames ? ' ' + customClassNames : ''
                }`}
            >
                {productSkus.length > 0 && (!slideConfig || slideConfig.slidesToShow > 0)? (
                    <div>
                        <div className={isMobile ? "product-carousel-mobile-component" : "product-carousel-desktop-component"}>
                            { header && <h2 className="carousel-header">{header}</h2> }
                            {
                                <Carousel
                                    {...carouselProps}
                                    renderBottomCenterControls={false}
                                    id="product-carousel-richtext"
                                    className={`product-carousel-richtext${className ? ' ' + className : ''}${
                                        customClassNames ? ' ' + customClassNames : ''
                                    }`}
                                    {
                                        ...isMobile 
                                        ? this.getXSellMobileSettings() 
                                        : { ...this.getXSellSettings(productSkusLength), style: carouselStyle }
                                    }
                                    {...(slideConfig || {})}
                                    ref={carousel => (carousel = carousel)}
                                >
                                    {this.getProductSkus(productSkus)}
                                </Carousel>
                            }
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isMobile: state && state.ui && state.ui.width && state.ui.width <= 820,
    breakpoint: state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints['stellar-grid'],
})

const mapDispatchToProps = dispatch => ({
    fetchProductGroups: skus => dispatch(fetchProductGroups(skus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarousel);
